
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns72a8c542b6b393fd85cc6ff59cc3ae7cen from './en.yaml'
            i18n.addResourceBundle('en', '72a8c542b6b393fd85cc6ff59cc3ae7c', flattenObject(ns72a8c542b6b393fd85cc6ff59cc3ae7cen), true, true);
        
        export default '72a8c542b6b393fd85cc6ff59cc3ae7c';
    